import React from 'react';
import { 
  useScrollTrigger,
  Slide,
  Fab,
  useTheme
} from '@mui/material';
import { ArrowUpward } from '@mui/icons-material';

function ScrollTop() {
  const theme = useTheme();
  const trigger = useScrollTrigger({
    threshold: 100,
  });

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Slide in={trigger} direction="up">
      <Fab
        color="secondary"
        size="medium"
        onClick={handleClick}
        sx={{
          position: "fixed",
          bottom: 32,
          right: 32,
          boxShadow: `0 0 15px ${theme.palette.secondary.main}`,
          [theme.breakpoints.down("sm")]: {
            bottom: 16,
            right: 16,
            width: 40,
            height: 40,
          },
        }}
      >
        <ArrowUpward />
      </Fab>
    </Slide>
  );
}

export default ScrollTop;